module.exports = "/virtual-football-league/img/video/virtualf-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/virtualf-logo.png
// module id = 2247
// module chunks = 4